//function to set all keys in an object to lowercase

export const toLowerCaseObject = (obj: object) => {
    return Object.keys(obj).reduce((accumulator: any, key: string) => {
        type ObjectKey = keyof typeof obj;
        accumulator[key.toLocaleLowerCase().replaceAll(" ", "_")] = obj[key as ObjectKey];
        return accumulator;
      }, {});
}